import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { SearchResult } from '../../interfaces/interfaces';
import WKT from 'ol/format/WKT';
import { Geometry, Point } from 'ol/geom';
import { reprojectCoordTo3857 } from '../../util';
import GeoJSON from 'ol/format/GeoJSON';
//import { SearchResult as BevSearchResponse, SearchResultDataFeatures } from './bevBindings';
import { FeatureCollection as BevFeatureCollection, Feature as BevFeature, Geometry as BevGeometry, GeoJsonProperties as BevGeoJsonProperties } from './geojson';
import { Feature } from 'ol';
import { getCenter } from 'ol/extent';


/* needed to parse well known text format */
const wktFormat = new WKT();

/* BEV YAML is unfortunately currently invalid so a custzom mapping is necessary 11.2022 */
interface BevSearchResponse {
  searchTerm: string,
  data: BevFeatureCollection
}

const geoJson = new GeoJSON();

const parse2Features = (geoJsonObject: BevFeatureCollection<BevGeometry, BevGeoJsonProperties>) => geoJson.readFeatures(geoJsonObject, {
  dataProjection: 'EPSG:4326',
  featureProjection: 'EPSG:3857'
});




const transform2SearchResult = (feature: Feature): SearchResult => {
  const extent = feature.getGeometry()?.getExtent();
  return {
    id: feature.getId() ? "" : 'undefined',
    layer: 'Katastralgemeinde Nr. Grundstück Nr.',
    label: `${feature.get('kg')} ${feature.get('gnr')}`,
    centroid: extent ? getCenter(extent) : [0, 0],
    extent: extent ? extent : [0, 0, 0, 0],
  }
}


const parseGstkSearchDoc = (featureCollection: BevFeatureCollection<BevGeometry, BevGeoJsonProperties>): SearchResult[] => {
  const features = parse2Features(featureCollection);
  let searchResult: SearchResult[] = [];

  features.forEach(feat => {
    if (feat.get('objectType') === 5) {
      searchResult.push(transform2SearchResult(feat));
 
    }
  });
  console.log("gstk search result");
  console.log(searchResult);
  return searchResult;

};

export const parseGstkSearchResponse = (searchResponse: BevSearchResponse): SearchResult[] => {
  if (searchResponse && searchResponse.data && searchResponse.data.features) {
    return parseGstkSearchDoc(searchResponse.data);
  } else {
    return [];
  }
}

// Define a service using a base URL and expected endpoints
export const gstkApi = createApi({
  reducerPath: 'gstkSearchApi',
  baseQuery: fetchBaseQuery({ baseUrl: 'https://kataster.bev.gv.at' }),
  endpoints: (builder) => ({
    searchGstk: builder.query<BevSearchResponse, string>({
      query: (query) => ({
        url: '/api/all',  // the url below the base url.
        params: query !== undefined ? { 'term': query } : undefined // the parameters if any
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useSearchGstkQuery } = gstkApi;



